<template>
  <layout-basic>
    <v-container fluid class="pb-5">
      <v-row>
        <v-col class="Full-Course-Library-Title pt-0"> My Team </v-col>
      </v-row>
      <v-row style="justify-content: space-between" class="mb-4 mt-4">
        <v-col cols="12" md="3" class="">
          <v-text-field class="search-box" placeholder="Search Users By Name Or Email" prepend-icon="fa-search" v-model="search"
            type="text" clearable clear-icon="fa-times" @click:clear="resetSearch" @change="applySearch"></v-text-field>
        </v-col>
        <!-- <v-col md="5" class="mt-4"></v-col> -->
        <v-col cols="12" md="6" class="myteam-button-wrapper">
          <v-btn
                class="ml-0 add-course-button"
                color="primary"
                to="/external-training"
                outlined
              >
              External Training
          </v-btn>
          <v-btn
            class="mr-1 add-course-button"
            color="primary"
            @click.prevent="emailMyTeamReport()"
            outlined
          >
          Email My Team Report
          </v-btn>
          <v-btn color="primary" outlined @click.prevent="showGroupEnrolPanel" class="add-course-button">
            Assign Courses
          </v-btn>
          <v-btn color="primary" outlined @click.prevent="showEnrolChannelPanel" class="add-course-button">
            Assign Playlists
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="loading" fluid class="pt-0">
      <v-row>
        <v-col md="12" class="pt-0 mb-4">
          <v-container grid-list-md fluid class="pa-0">
            <v-layout wrap>
              <v-flex v-for="index in 6" :key="index" xs12 sm6 lg4 class="mb-5">
                <v-card :class="['card-outter', 'pb-0', { 'mr-6': isTabletOrDesktop }]" height="100%">
                  <v-skeleton-loader elevation="2" class="card-loader"
                    type="list-item-avatar,list-item-two-line">
                  </v-skeleton-loader>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else fluid class="pt-0 pr-2">
      <v-row>
        <v-col md="12" class="pt-0 mb-4">
          <v-container v-if="users.length == 0" style="padding: 0px">
            <h2>No Team Found</h2>
          </v-container>
          <v-container v-else grid-list-md fluid class="pa-0">
            <v-layout wrap>
              <v-flex v-for="user in users" :key="user.id" xs12 sm6 md3 lg4 class="mb-5">
                <user-card :user="user"></user-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/Dashboard';
import userAPI from '@/api/user.js';
import UserCard from '@/components/global/UserCard';
import EnrolTeamCourse from '@/components/admin/users/EnrolTeamCourse';
import EnrolChannel from '@/components/admin/users/EnrolTeamChannel';
import { EventBus } from '@/event-bus.js';

export default {
  name: 'MyTeam',
  components: {
    LayoutBasic,
    UserCard,
  },
  data() {
    return {
      search: '',
      users: {},
      loading: false,
      params: '?include=thumbnail,enrolled&limit=999999',
      searchParams: '',
      successMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
    };
  },
  computed: {
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.getManagerUsers();
    this.setEventBus();
  },
  methods: {
    getManagerUsers() {
      this.loading = true;
      let searchUsersParams = this.params;
      if (this.searchParams) {
        searchUsersParams = this.params + this.searchParams;
      }
      userAPI.getManagerTeams(searchUsersParams).then((response) => {
        this.loading = false;
        this.users = response.data.data;
      });
    },
    resetSearch() {
      this.searchParams = '';
      this.getManagerUsers();
    },
    applySearch() {
      this.searchParams = '';
      if (this.search != null) {
        this.searchParams =
          '&search=first_name:' + this.search + ';last_name:' + this.search + ';email:' + this.search;
      }
      this.getManagerUsers();
    },
    showGroupEnrolPanel() {
      this.$showPanel({
        component: EnrolTeamCourse,
        disableBgClick: true,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showEnrolChannelPanel() {
      this.$showPanel({
        component: EnrolChannel,
        disableBgClick: true,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    setEventBus() {
      EventBus.$on('TEAM_COURSES_UPDATED', () => {
        this.getManagerUsers();
      });
    },
    emailMyTeamReport(){
      this.loading = true;
      userAPI
        .emailMyTeamReport()
        .then(() => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  },
};
</script>

<style>
.myteam-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}

@media (max-width: 960px) {
  .myteam-button-wrapper {
    justify-content: start;
  }
}
</style>
